<template>
<div container--fluid>
    <v-layout>
        <HpcEnrollModule></HpcEnrollModule>
    </v-layout>
</div>
</template>

<script>
import HpcEnrollModule from '@modules/hpcenroll/index.vue';

export default {
    name: 'hpcenroll',
    components: {
        HpcEnrollModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
